var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":""}},[_c('div',{staticClass:"lower-font-size"},[_c('b-form-checkbox',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.propertyValue),callback:function ($$v) {_vm.propertyValue=$$v},expression:"propertyValue"}},[_vm._v("\n      "+_vm._s(_vm.properties.label)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }